import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.user.monitoring');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wiz-page-user-monitoring',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.user.monitoring/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageUserMonitoringComponent implements OnInit, OnDestroy {

    public type: string | null = null;
    private routerSub: Subscription;

    constructor(@Inject( Service)         public service: Service,@Inject( Title)         private title: Title,@Inject( Router    )         private router: Router    ) { }

    async ngOnInit() {
        await this.service.init();

        this.title.setTitle("모니터링 관리");

        this.type = WizRoute.segment.type || null;

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newType = WizRoute.segment.type || null;
                if (newType !== this.type) {
                    this.type = newType;
                    await this.service.render();
                }
            }
        });

        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }
}

export default PageUserMonitoringComponent;